import styled from "styled-components";
import img from "../../assets/images/footer_logo.png"
import MDInput from "../MDInput";
import MDMenu from "../MDMenu";
import { Link } from "react-router-dom";
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import { connect } from "react-redux";
import { Grid ,Box} from "@mui/material";


const Container = styled.div`
    background:${props => props.theme.colors.main.default};
    padding:50px 30px;
    & li{
        font-weight:600!important;
    }
    @media(max-width:351px){
        padding:50px 5px;
    }
    @media(min-width:351px) and (max-width:768px){
        padding:50px 10px;
    }
    @media(min-width:768px) and (max-width:1257px){
        padding:50px 5px;
    }
`
const ContainerFinal = styled.div`
    background:${props => props.theme.colors.dark.default};
    display:flex;
    justify-content:center;
    letter-spacing:1.5px;
    padding:15px 0;
    color: white;
    font-size:${props => props.theme.typography.Montserrat_SemiBold_base.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_SemiBold_base.weight};
    font-family:${props => props.theme.typography.Montserrat_SemiBold_base.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_SemiBold_base.lineHeight};
`
const Group = styled.div`
    display:flex;
    
    // gap:80px;
    @media(max-width:992px){
        flex-direction:column;
        gap:30px
    }
    @media(min-width:993px){
        justify-content:space-between;
    }
`
const BaseGroupItem =styled.div`
    width:30%;
    padding:0 10px 0 20px;
    @media (max-width : 500px){
        width:80%;  
        margin:auto;
        text-align:center;
        padding:0 ;
    }
    @media (min-width:500px) and (max-width : 992px){
      width:50%;  
      margin:auto;
      padding:0 ;
      text-align:center;
    }


`
const Typography = styled.p`
    color:white;
    padding-left:20px;
    font-size:${props => props.theme.typography.Montserrat_Regular_base.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_Regular_base.weight};
    font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_Regular_base.lineHeight};
    @media(max-width:992px){
        padding:0;
    }

`
const SocialGroup = styled.ul`
    display : flex;
    padding-left:20px;
    margin-top:40px;
    gap:24px;
    list-style-type: none;
    @media (max-width:992px){
       justify-content:center;
       padding:0;
        
    }

`
const ItemSocialGroup = styled.li`
transition: 0.3s ;
&:hover{
    cursor:pointer;
    border-radius:4px;
    transform:scale(1.2)
}

`
const TitleGroup = styled.h4`
    color: white;
    font-size:${props => props.theme.typography.Montserrat_Bold_2xl.fontSize};
    // font-weight:${props => props.theme.typography.Montserrat_Bold_2xl.weight};
    font-weight:600;
    font-family:${props => props.theme.typography.Montserrat_Bold_2xl.fontFamily};
    // line-height:${props => props.theme.typography.Montserrat_Bold_2xl.lineHeight};
    line-height:70px;
     @media(min-width:993px) and (max-width:1200px){
        font-size:18px
    }
`
const ListGroup = styled.ul`
    list-style-type : none;
  
`
const GroupItemSearch = styled.div`
    color: white;
    padding:0 10px;
    font-size:${props => props.theme.typography.Montserrat_SemiBold_base.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_SemiBold_base.weight};
    font-family:${props => props.theme.typography.Montserrat_SemiBold_base.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_SemiBold_base.lineHeight};
    // @media(min-width:500px){
    //     width:90%;
    //     margin:auto;
    // }
    // @media(min-width:500px) and (max-width:768px){
    //     width:65%;
    //     margin:auto;
    // };
    // @media (min-width:769px) and (max-width:992px){
    //     width:70%;
    //     margin:auto
    // };
    @media(max-width:992px){
        & h4{
            text-align:center;
        }
        & ul li{
          margin: auto!important;
          width: fit-content;  
        }
        margin: auto!important;
        width: fit-content;
    }
    @media (min-width:993px) and (max-width:1250px) {
        // font-size:19px;
        width:29%;
        margin:auto;
    };
    @media (min-width:1250px) {
        // font-size:19px;
        width:30%;
        
        margin:auto;
    }

`
const GroupColumn = styled.div`
    display:flex;
    @media(max-width:768px){
        flex-direction:column;
    };
    @media (min-width:768px) and (max-width: 992px){
        // width:60%;
        margin:auto;
    }
    @media(min-width:993px){
        gap:20px
    }
  
    
    

`
const GroupItem = styled.div`
    padding:0 20px;
    @media(max-width:768px){
        text-align:center;
        margin:auto;
        & li{
            text-align:center;
        }
    }
    @media(min-width:992px) and (max-width:1153px){
        padding:0 10px; 
    }


`
const ItemListGroup = styled.li`
    color: white;
    // font-size:${props => props.theme.typography.Montserrat_SemiBold_base.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_SemiBold_base.weight};
    font-family:${props => props.theme.typography.Montserrat_SemiBold_base.fontFamily};
    // line-height:${props => props.theme.typography.Montserrat_SemiBold_base.lineHeight};
    line-height:30px;
    font-size:16px;
    &:hover{
        cursor:pointer;
    }
    @media(min-width:993px) and (max-width:1250px){
        font-size:14px
    }
   

`
const Icon = styled.div`

    margin-right: 10px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:15px
   

`
const Path = styled.path`
    fill:${props => props.theme.colors.main.default};
`


function MDFooter({telegram_number,facebook_link,youtube_link,whatsapp_number,main_email}) {
    const infoContact =[{
        name:"Location",
        href:"https://www.google.com/maps/place/58+Rue+Conrad-Val%C3%A9ra,+Gatineau,+QC+J9J+3L7,+Canada/@45.4095437,-75.8247049,17z/data=!3m1!4b1!4m6!3m5!1s0x4cce023b2ce14265:0x7ba2a640937fa9e5!8m2!3d45.40954!4d-75.82213!16s%2Fg%2F11csb3qnp6?entry=ttu",
        icon:<LocationOnIcon style={{color:"white"}} />
        // icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        // <path d="M12 15.93C15.1038 15.93 17.62 13.4138 17.62 10.31C17.62 7.20616 15.1038 4.69 12 4.69C8.89616 4.69 6.38 7.20616 6.38 10.31C6.38 13.4138 8.89616 15.93 12 15.93Z" stroke="white" stroke-width="5"/>
        // <path d="M18.4293 8.94149L18.4293 8.94158C19.3317 12.9278 16.8832 16.5349 14.2147 19.0974L14.211 19.101C12.9782 20.2908 11.0244 20.296 9.77638 19.0985C7.11788 16.5359 4.66844 12.9195 5.57034 8.93273C6.3105 5.68094 9.05556 3.99801 12.0024 4C14.9496 4.00199 17.6932 5.68922 18.4293 8.94149Z" stroke="white" stroke-width="4"/>
        // </svg>
    },{
        name:"+1 343-987-4565",
        href:"tel:13439874565",
        // name:whatsapp_number,
        // href:`tel:${whatsapp_number}`,
        icon:<PhoneIcon style={{color:"white"}} />
        // icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        // <path d="M18.6415 19.7694L18.6416 19.7694C18.9446 19.6452 19.2449 19.442 19.5587 19.0963L18.6415 19.7694ZM18.6415 19.7694L18.6308 19.7738M18.6415 19.7694L18.6308 19.7738M18.6308 19.7738C18.2837 19.9185 17.8961 20 17.45 20C16.7463 20 15.9232 19.8345 14.974 19.4301C13.9777 19.0056 12.9591 18.4243 11.9287 17.6742C10.864 16.8965 9.85251 16.0341 8.88425 15.0758C7.92671 14.1083 7.06605 13.0988 6.30029 12.0475C5.55304 11.0081 4.97363 9.9992 4.56207 9.03102C4.16714 8.09221 4 7.26724 4 6.54C4 6.09702 4.07771 5.70089 4.21695 5.35278L4.21698 5.35279M18.6308 19.7738L4.21698 5.35279M4.21698 5.35279L4.22113 5.34225M4.21698 5.35279L4.22113 5.34225M4.22113 5.34225C4.34682 5.02279 4.55309 4.7055 4.88244 4.39479L4.89789 4.38021M4.22113 5.34225L4.89789 4.38021M4.89789 4.38021L4.91303 4.36531M4.89789 4.38021L4.91303 4.36531M4.91303 4.36531C5.19042 4.09225 5.3864 4.02135 5.51504 4.0047M4.91303 4.36531L5.51504 4.0047M5.51504 4.0047L7.75883 7.16728L7.75879 7.16731L7.76693 7.17861C7.78559 7.20452 7.80238 7.22873 7.81748 7.2513C7.79608 7.27446 7.77225 7.29932 7.74579 7.32579L7.7321 7.33947L7.71868 7.35342L6.96763 8.13412C6.46437 8.64723 6.24 9.29261 6.24 9.93C6.24 10.1995 6.27688 10.4337 6.32972 10.6451L6.35734 10.7556L6.39734 10.8623C6.42543 10.9372 6.45372 11.0042 6.46682 11.035L6.50894 11.1614L6.59421 11.3177C6.86872 11.821 7.27784 12.3701 7.75323 12.9319L7.7604 12.9404L7.76766 12.9488C8.23801 13.4923 8.74661 14.0542 9.30238 14.6207L9.3156 14.6342L9.32906 14.6474C9.88514 15.1931 10.4435 15.7204 11.0255 16.2146L11.0281 16.2168C11.6073 16.7068 12.1597 17.1052 12.6742 17.3776L12.7683 17.4274L12.848 17.4593L12.8592 17.4644L12.8664 17.4677C12.8927 17.4798 12.9453 17.5039 13.0022 17.5283L13.0446 17.5465L13.0878 17.5627C13.46 17.7023 13.7951 17.73 14.04 17.73C14.7656 17.73 15.3941 17.4413 15.858 16.9804L16.6148 16.2335L16.6148 16.2336L16.6242 16.2242C16.6565 16.192 16.6858 16.164 16.7122 16.1398C16.742 16.1584 16.7746 16.1796 16.8103 16.2036L19.9571 18.4378C19.9481 18.4762 19.9337 18.5189 19.9115 18.566C19.821 18.7576 19.7088 18.9305 19.5589 19.096L5.51504 4.0047Z" stroke="white" stroke-width="4" stroke-miterlimit="10"/>
        // </svg>
    },{
        name:main_email,
        href:`mailto:${main_email}`,
        icon:<EmailIcon style={{color:"white"}} />
        // icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        // <path d="M12 11.1075L21.585 4.95C21.1997 4.66096 20.7317 4.50323 20.25 4.5H3.75004C3.26834 4.50323 2.8004 4.66096 2.41504 4.95L12 11.1075Z" fill="white"/>
        // <path d="M12.405 12.63L12.2775 12.69H12.2175C12.1484 12.7209 12.0751 12.7411 12 12.75C11.9377 12.7579 11.8748 12.7579 11.8125 12.75H11.7525L11.625 12.69L1.575 6.19501C1.52698 6.37616 1.50179 6.56261 1.5 6.75001V17.25C1.5 17.8467 1.73705 18.419 2.15901 18.841C2.58097 19.263 3.15326 19.5 3.75 19.5H20.25C20.8467 19.5 21.419 19.263 21.841 18.841C22.2629 18.419 22.5 17.8467 22.5 17.25V6.75001C22.4982 6.56261 22.473 6.37616 22.425 6.19501L12.405 12.63Z" fill="white"/>
        // </svg>
    }
    ]
   
    return ( <div>
        <Container>
            <Grid container sx={{
                "@media(min-width:993px)":{
                    justifyContent:"space-between"
                }
            }}> 
                <Grid  item lg={3} md={12} sm={12} xs={12}>
                    <Box sx={{
                        "@media(max-width:992px)":{
                            textAlign:"center",
                            padding:"0 30px"
                        },
                        "@media(min-width:993px)":{
                           paddingRight:"20px"
                        }
                    }}>
                    <div>
                    <img src={img}/>
                </div>
                <Typography>
                Welcome to <strong>Shake Shake</strong>, Where the thrill of unboxing meets the joy of discovery and 
                the opportunity for profit.
                </Typography>

                <SocialGroup>
                    <ItemSocialGroup>
                        <Link target="_blank" to={youtube_link}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <g clipPath="url(#clip0_63_813)">
                        <path d="M24.8175 0H7.18254C3.21573 0 0 3.21573 0 7.18254V24.8175C0 28.7843 3.21573 32 7.18254 32H24.8175C28.7843 32 32 28.7843 32 24.8175V7.18254C32 3.21573 28.7843 0 24.8175 0Z" fill="white"/>
                        <Path fillRule="evenodd" clipRule="evenodd" d="M8.86638 21.9134C8.54652 21.8165 8.25467 21.644 8.01546 21.4106C7.77624 21.1772 7.59669 20.8896 7.49194 20.5722C6.8934 18.9318 6.71605 12.0818 7.8688 10.7295C8.25246 10.2896 8.79414 10.0188 9.37625 9.97578C12.4687 9.64325 22.0233 9.68759 23.1206 10.0866C23.4293 10.1868 23.7112 10.3554 23.9454 10.58C24.1796 10.8046 24.3599 11.0793 24.4729 11.3835C25.1269 13.0793 25.149 19.2421 24.3842 20.8715C24.1813 21.2957 23.8417 21.6392 23.4199 21.8469C22.2671 22.4233 10.396 22.4122 8.86638 21.9134ZM13.7767 18.699L19.3188 15.8171L13.7767 12.9131V18.699Z" />
                        </g>
                        <defs>
                        <path id="clip0_63_813">
                        <rect width="32" height="32" fill="white"/>
                        </path>
                        </defs>
                        </svg>
                        </Link>
                    </ItemSocialGroup>
                    <ItemSocialGroup>
                        <Link target="_blank" to={whatsapp_number}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <g clipPath="url(#clip0_63_823)">
                            <path d="M31.9988 23.9117C31.9988 24.0869 31.9934 24.4669 31.9829 24.7604C31.9572 25.4786 31.9002 26.4054 31.8141 26.8277C31.6847 27.4622 31.4894 28.0612 31.2347 28.5597C30.9333 29.1494 30.549 29.6777 30.0922 30.1336C29.6365 30.5886 29.1087 30.9714 28.5199 31.2716C28.0188 31.5269 27.4161 31.7224 26.7779 31.8512C26.3598 31.9356 25.44 31.9915 24.7264 32.0168C24.4326 32.0273 24.0525 32.0326 23.8779 32.0326L8.12087 32.0301C7.94566 32.0301 7.56572 32.0247 7.27219 32.0142C6.55397 31.9884 5.62722 31.9315 5.20494 31.8454C4.57037 31.716 3.97141 31.5207 3.47291 31.266C2.88316 30.9646 2.35494 30.5802 1.89903 30.1235C1.44403 29.6677 1.06116 29.14 0.761063 28.5512C0.505625 28.05 0.310188 27.4473 0.181344 26.8092C0.0969687 26.3911 0.041125 25.4713 0.0157188 24.7577C0.00528125 24.4639 0 24.0838 0 23.9093L0.0025 8.15216C0.0025 7.97694 0.00784375 7.59697 0.018375 7.30344C0.0441562 6.58522 0.101062 5.65847 0.187156 5.23622C0.316562 4.60166 0.511875 4.00269 0.766594 3.50416C1.06794 2.91444 1.45234 2.38619 1.90906 1.93028C2.36481 1.47531 2.89256 1.09241 3.48141 0.792281C3.98256 0.536906 4.58528 0.341469 5.22344 0.212625C5.64147 0.128219 6.56131 0.072375 7.27494 0.047C7.56875 0.0365312 7.94884 0.03125 8.12334 0.03125L23.8804 0.0337813C24.0557 0.0337813 24.4356 0.039125 24.7292 0.0496563C25.4474 0.0754375 26.3741 0.132344 26.7964 0.218437C27.4309 0.347844 28.0299 0.543156 28.5284 0.797875C29.1182 1.09922 29.6464 1.48362 30.1023 1.94034C30.5573 2.39609 30.9402 2.92381 31.2403 3.51269C31.4957 4.01384 31.6911 4.61653 31.82 5.25469C31.9043 5.67275 31.9602 6.59256 31.9856 7.30622C31.9961 7.60003 32.0013 7.98009 32.0013 8.15466L31.9988 23.9117Z" fill="white"/>
                            <Path d="M24.4783 7.60064C22.3118 5.4323 19.4305 4.23755 16.3607 4.23633C10.0357 4.23633 4.88781 9.3822 4.88528 15.7073C4.88447 17.7292 5.41287 19.7028 6.41706 21.4424L4.78906 27.387L10.8723 25.7918C12.5485 26.7057 14.4355 27.1873 16.3562 27.1881H16.3609C22.6853 27.1881 27.8336 22.0416 27.8362 15.7165C27.8374 12.6512 26.6449 9.76898 24.4783 7.60064ZM16.3609 25.2507H16.357C14.6455 25.25 12.9669 24.7904 11.5025 23.9216L11.1542 23.715L7.54425 24.6617L8.50781 21.1432L8.28097 20.7824C7.32622 19.2643 6.82197 17.5096 6.82272 15.7081C6.82478 10.4509 11.1035 6.17383 16.3646 6.17383C18.9121 6.1748 21.3069 7.16792 23.1077 8.97014C24.9084 10.7724 25.8996 13.168 25.8987 15.7157C25.8966 20.9733 21.6179 25.2507 16.3609 25.2507ZM21.5926 18.1096C21.3058 17.9661 19.8962 17.2726 19.6333 17.177C19.3705 17.0813 19.1794 17.0335 18.9882 17.3205C18.7971 17.6074 18.2476 18.2531 18.0803 18.4444C17.913 18.6357 17.7457 18.6596 17.459 18.5161C17.1723 18.3726 16.2484 18.07 15.1532 17.0934C14.3009 16.3335 13.7254 15.3947 13.5581 15.1077C13.3909 14.8207 13.5403 14.6656 13.6839 14.5227C13.8128 14.3943 13.9706 14.1879 14.114 14.0205C14.2573 13.8532 14.3051 13.7336 14.4007 13.5423C14.4963 13.351 14.4485 13.1836 14.3768 13.0401C14.3051 12.8966 13.7317 11.4858 13.4927 10.9119C13.26 10.3529 13.0236 10.4285 12.8476 10.4198C12.6805 10.4115 12.4892 10.4097 12.298 10.4097C12.1069 10.4097 11.7963 10.4814 11.5334 10.7684C11.2706 11.0554 10.5299 11.7488 10.5299 13.1597C10.5299 14.5705 11.5573 15.9335 11.7007 16.1248C11.8441 16.3161 13.7225 19.2114 16.5988 20.453C17.283 20.7483 17.817 20.9247 18.2335 21.0568C18.9203 21.2749 19.5454 21.2442 20.0395 21.1704C20.5904 21.0881 21.7359 20.477 21.9749 19.8074C22.2138 19.1378 22.2138 18.564 22.1421 18.4444C22.0704 18.3248 21.8793 18.2531 21.5926 18.1096Z" />
                            </g>
                            <defs>
                            <path id="clip0_63_823">
                            <rect width="32" height="32" fill="white"/>
                            </path>
                            </defs>
                            </svg>
                        </Link>
                    </ItemSocialGroup>
                    <ItemSocialGroup>
                    <Link target="_blank" to={facebook_link}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <g clipPath="url(#clip0_63_810)">
                        <path d="M28 0H4C1.794 0 0 1.794 0 4V28C0 30.206 1.794 32 4 32H28C30.206 32 32 30.206 32 28V4C32 1.794 30.206 0 28 0Z" fill="white"/>
                        <Path fillRule="evenodd" clipRule="evenodd" d="M27 16H22V12C22 10.896 22.896 11 24 11H26V6H22C20.4087 6 18.8826 6.63214 17.7574 7.75736C16.6321 8.88258 16 10.4087 16 12V16H12V21H16V32H22V21H25L27 16Z" fill="#7934BE"/>
                        </g>
                        <defs>
                        <path id="clip0_63_810">
                        <rect width="32" height="32" fill="white"/>
                        </path>
                        </defs>
                        </svg>
                    </Link>
                    </ItemSocialGroup>
                    <ItemSocialGroup>
                        <Link target="_blank" to={telegram_number}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" style={{borderRadius:"4px"}}>
                            <g clipPath="url(#clip0_63_818)">
                            <path d="M31.9906 0H0.009375C0.00419733 0 0 0.00419733 0 0.009375V31.9906C0 31.9958 0.00419733 32 0.009375 32H31.9906C31.9958 32 32 31.9958 32 31.9906V0.009375C32 0.00419733 31.9958 0 31.9906 0Z" fill="white"/>
                            <path d="M12.4375 25.25C11.75 25.25 11.8125 25 11.625 24.375L9.625 17.8125L24.9375 8.8125" fill="white"/>
                            <Path d="M12.4375 25.25C12.875 25.25 13.125 25 13.4375 24.75L16.25 22.0625L12.75 19.9375" />
                            <Path d="M12.7505 19.9388L21.188 26.1263C22.063 26.6888 22.813 26.3763 23.063 25.2513L26.5005 9.12625C26.813 7.75125 25.938 7.12625 25.0005 7.56375L4.93802 15.3138C3.62552 15.8138 3.62552 16.6263 4.68802 16.9388L9.87552 18.5638L21.7505 11.0013C22.313 10.6888 22.813 10.8138 22.438 11.2513" />
                            </g>
                            <defs>
                            <path id="clip0_63_818">
                            <rect width="32" height="32" rx="4" fill="white"/>
                            </path>
                            </defs>
                            </svg>
                        </Link>

                    </ItemSocialGroup>

                </SocialGroup>
                    </Box>
                </Grid>
                <Grid  className="menu-pages" item lg={3} md={6} sm={12} xs={12}>
                    <Box sx={{
                        "@media(max-width:567px)":{
                            textAlign:"center",
                            "& li":{
                                width: "fit-content",
                                margin: "auto"
                            }
                        },
                        "@media(min-width:568px) and (max-width:992px)":{
                            width:"fit-content",
                            margin:"auto"
                        },
                        "@media(min-width:993px)":{
                            width:"fit-content",
                            margin:"auto"
                        }
                    }}>
                        <GroupItem>
                            <TitleGroup>About us</TitleGroup> 
                            <ListGroup>{
                                [{name:"About",href:"/page/about"},
                                {name:"Privacy policy",href:"/page/Privacy-policy"},
                                {name:"Terms and conditions",href:"/page/Terms-and-conditions"},
                                {name:"Return policy",href:"/page/policy"},
                                {name:"Shipping information",href:"/page/Shipping-information"}]
                                .map((e)=><ItemListGroup key={e.name}  ><Link to={e.href}>{e.name}</Link></ItemListGroup>)
                                
                            }
                            </ListGroup>
                        </GroupItem>
                        
                    </Box>
                </Grid>
                <Grid  className="menu-pages"  item lg={3} md={6} sm={12} xs={12}>
                    <Box sx={{
                        "@media(max-width:567px)":{
                            textAlign:"center",
                            "& li":{
                                width: "fit-content",
                                margin: "auto"
                            }
                        },
                        "@media(min-width:568px) and (max-width:992px)":{
                            alignItems:"center"
                        },
                        "@media(min-width:993px)":{
                            width:"fit-content",
                            margin:"auto"
                        }
                    }}>
                        <GroupItem>
                            <TitleGroup>Customer service</TitleGroup> 
                            <ListGroup style={{textAlign:"start"}}>{
                                [{name:`FAQ`,href:"/support/FAQs"},
                                {name:`Contact Us`,href:"/support/contact"},
                                {name:`Transformative Marketing`,href:"/support/Transformative-Marketing"}].map((e)=><ItemListGroup key={e.name}><Link to={e.href}>{e.name}</Link></ItemListGroup>)
                                
                            }
                            </ListGroup>
                        </GroupItem>
                    </Box>
                </Grid>
                <Grid  className="menu-pages" item lg={3} md={12} sm={12} xs={12}>
                <Box sx={{
                    "@media(max-width:992px)":{
                        textAlign:"center",
                        "& li":{
                            width: "fit-content",
                            margin: "auto"
                        }
                    },
                    "@media(min-width:993px)":{
                        width:"fit-content",
                        margin:"auto"
                    }
                }}>
                    {/* <TitleGroup>Subscribe to our newsletter </TitleGroup>  */}
                <TitleGroup>Contact Info </TitleGroup> 
                {/* <MDInput  isSubscribe={true} icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                    <path d="M10 11.25C9.3543 11.25 8.70859 11.0382 8.15781 10.609L0 4.26562V13.125C0 14.1602 0.839453 15 1.875 15H18.125C19.1605 15 20 14.1605 20 13.125V4.26562L11.8438 10.6133C11.293 11.0391 10.6445 11.25 10 11.25ZM0.636328 3.17578L8.92539 9.625C9.55781 10.1172 10.4437 10.1172 11.0762 9.625L19.3652 3.17578C19.7305 2.86328 20 2.38281 20 1.875C20 0.839453 19.1602 0 18.125 0H1.875C0.839453 0 0 0.839453 0 1.875C0 2.38281 0.234766 2.86328 0.636328 3.17578Z" fill="#B5B5B5"/>
                    </svg>} placeholder="Email" /> */}
                <MDMenu isNav={false} data={infoContact} />
                {/* <IconButton sx={{position:"absolute",right:"-30px",top:"37%",transform:"translateY(-50%)",zIndex:"5"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 43 37" fill="none">
                    <path d="M40.0976 0.243284L2.00783 15.3131C-0.591634 16.3843 -0.576595 17.8722 1.53091 18.5356L11.3101 21.6655L33.9362 7.01887C35.006 6.35101 35.9835 6.71029 35.1801 7.44207L16.8484 24.4163H16.8441L16.8484 24.4185L16.1739 34.7604C17.1621 34.7604 17.5982 34.2954 18.1525 33.7465L22.9024 29.0076L32.7825 36.4951C34.6043 37.5244 35.9126 36.9954 36.3659 34.7648L42.8517 3.40405C43.5155 0.673095 41.8356 -0.563439 40.0976 0.243284Z" fill="#606060"/>
                </svg>
                </IconButton> */}
                </Box>
                </Grid>
            </Grid>
        <Group>
            {/* <BaseGroupItem>
                
            </BaseGroupItem>
            <GroupColumn className="menu-pages">
                
                
            </GroupColumn>
            <GroupItemSearch style={{position:"relative",margin:0}}  className="menu-pages">
                

            </GroupItemSearch>
             */}

        </Group>
        
    </Container>
    <ContainerFinal>
        <Icon> 
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0.25C8.07164 0.25 6.18657 0.821828 4.58319 1.89317C2.97982 2.96451 1.73013 4.48726 0.992179 6.26884C0.254225 8.05042 0.061142 10.0108 0.437348 11.9021C0.813554 13.7934 1.74215 15.5307 3.10571 16.8943C4.46928 18.2579 6.20656 19.1865 8.09787 19.5627C9.98919 19.9389 11.9496 19.7458 13.7312 19.0078C15.5127 18.2699 17.0355 17.0202 18.1068 15.4168C19.1782 13.8134 19.75 11.9284 19.75 10C19.7473 7.41498 18.7192 4.93661 16.8913 3.10872C15.0634 1.28084 12.585 0.25273 10 0.25ZM10 18.25C8.36831 18.25 6.77326 17.7661 5.41655 16.8596C4.05984 15.9531 3.00242 14.6646 2.378 13.1571C1.75358 11.6496 1.5902 9.99085 1.90853 8.3905C2.22685 6.79016 3.01259 5.32015 4.16637 4.16637C5.32016 3.01259 6.79017 2.22685 8.39051 1.90852C9.99085 1.59019 11.6497 1.75357 13.1571 2.37799C14.6646 3.00242 15.9531 4.05984 16.8596 5.41655C17.7661 6.77325 18.25 8.3683 18.25 10C18.2475 12.1873 17.3775 14.2843 15.8309 15.8309C14.2843 17.3775 12.1873 18.2475 10 18.25ZM7 10C7 10.6296 7.19812 11.2433 7.56628 11.7541C7.93444 12.2649 8.45399 12.6469 9.05132 12.8461C9.64866 13.0452 10.2935 13.0513 10.8945 12.8635C11.4955 12.6758 12.0222 12.3037 12.4 11.8C12.5195 11.6409 12.6973 11.5357 12.8943 11.5077C13.0913 11.4796 13.2913 11.531 13.4505 11.6505C13.6096 11.7699 13.7148 11.9477 13.7428 12.1447C13.7708 12.3417 13.7195 12.5418 13.6 12.7009C13.0332 13.4563 12.2431 14.0142 11.3416 14.2956C10.4402 14.577 9.473 14.5676 8.57713 14.2689C7.68126 13.9701 6.90208 13.3971 6.34995 12.631C5.79781 11.8648 5.50071 10.9444 5.50071 10C5.50071 9.05563 5.79781 8.13519 6.34995 7.36904C6.90208 6.60289 7.68126 6.02986 8.57713 5.73111C9.473 5.43236 10.4402 5.42302 11.3416 5.70443C12.2431 5.98583 13.0332 6.54371 13.6 7.29906C13.6592 7.37786 13.7022 7.46753 13.7267 7.56296C13.7512 7.6584 13.7567 7.75772 13.7428 7.85527C13.7289 7.95281 13.696 8.04667 13.6458 8.13147C13.5956 8.21628 13.5293 8.29037 13.4505 8.34953C13.3717 8.40869 13.282 8.45175 13.1866 8.47625C13.0911 8.50075 12.9918 8.50621 12.8943 8.49232C12.7967 8.47844 12.7029 8.44548 12.6181 8.39532C12.5333 8.34516 12.4592 8.27879 12.4 8.2C12.0222 7.69628 11.4955 7.3242 10.8945 7.13646C10.2935 6.94872 9.64866 6.95484 9.05132 7.15395C8.45399 7.35306 7.93444 7.73507 7.56628 8.24587C7.19812 8.75667 7 9.37035 7 10Z" fill="white"/>
            </svg>
        </Icon>
        <Icon>
            All rights reserved. 2023
        </Icon>
    </ContainerFinal>
    </div>
     );
}
const mapStateToProps = (state)=>{
    return {
        telegram_number:state.telegram_number,
        facebook_link:state.facebook_link,
        youtube_link:state.youtube_link,
        whatsapp_number:state.whatsapp_number,
        main_email:state.main_email
    }
}
export default connect(mapStateToProps,null)(MDFooter);